module.exports = __webpack_public_path__ + "static/img/h_17@2x.25668d36.png";